import * as t from "io-ts";

export const codec = t.union([
    t.literal("assigned"),
    t.literal("unassigned"),
    t.literal("irrelevant"),
]);

export type T = t.TypeOf<typeof codec>;
